/** Mínimo local da senha (FR-004). O servidor tem a palavra final. */
// Teto do contrato (`LoginRequest.senha.maxLength`): o bcrypt so considera os primeiros 72 bytes,
// e o teto evita mandar corpo arbitrario para hash. Nao ha minimo de forca no login — ver P13.
export const PASSWORD_MAX = 200;

export interface LoginFormValues {
  email: string;
  senha: string;
  /** "Mantenha-me conectado": 7 dias em vez de 8 h de inatividade (FR-007). */
  lembrar: boolean;
}

export const loginDefaults: LoginFormValues = {
  email: '',
  senha: '',
  lembrar: false,
};

/**
 * Rota para onde voltar depois de entrar (FR-007).
 *
 * Só aceita caminho interno: `//outro.host` e `https://…` viram `/`. O valor vem
 * da querystring, que qualquer um monta — um link de "login" que devolve o
 * usuário autenticado para fora do console seria phishing pronto.
 */
export function returnRoute(valor: string | null | undefined, padrao = '/'): string {
  if (!valor) return padrao;
  if (!valor.startsWith('/') || valor.startsWith('//')) return padrao;
  if (valor === '/login' || valor.startsWith('/login?')) return padrao;
  return valor;
}
